import React from 'react'
import Icon from './Icon'

const Button = (props) => {
    let { className, style, isLoading, onClick, disabled } = props
    className = className + ((isLoading && ' disabled') || '')
    return (
        <button className={className + ' btn'} style={style} onClick={onClick} disabled={isLoading || disabled} type={props.type}>
            {props.children}
            {(isLoading && <i className="spinner-border loading-icon ml-2"></i>) || null}
        </button>
    )
}

export default Button
